import { render, staticRenderFns } from "./MobileAccountCard.vue?vue&type=template&id=2bab69f7"
import script from "./MobileAccountCard.vue?vue&type=script&lang=js"
export * from "./MobileAccountCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports